(() => {
  'use strict';

  if (window.__sinLipomasReleasitCROV1) return;
  window.__sinLipomasReleasitCROV1 = true;

  const PRODUCT_ID = '10142170906920';
  const config = window.SinLipomasReleasitLegacyConfig || {};
  const images = config.images || {};
  const OFFER_ORDER = [2, 4, 6];
  const OFFER_COPY = {
    2: {
      title: 'RECIBE 2 SINLIPOMAS',
      plaque: 'OFERTA 2×1',
      detail: 'PAGAS 1 Y RECIBES 2',
      image: images.two,
    },
    4: {
      title: 'RECIBE 4 SINLIPOMAS',
      plaque: '20% DE DESCUENTO ADICIONAL',
      detail: 'AHORRAS $12.780',
      image: images.four,
    },
    6: {
      title: 'RECIBE 6 SINLIPOMAS',
      plaque: '45% DE DESCUENTO ADICIONAL',
      detail: 'AHORRAS $28.755',
      image: images.six,
    },
  };
  const SUMMARY_PRICING = {
    2: { subtotal: 127800, discount: 63900, total: 63900 },
    4: { subtotal: 255600, discount: 140580, total: 115020 },
    6: { subtotal: 383400, discount: 220455, total: 162945 },
  };

  const formatCOP = (value) => `$${Number(value).toLocaleString('es-CO')} COP`;
  const parseCOP = (value) => Number(String(value || '').replace(/[^0-9]/g, ''));

  const findFirst = (root, selectors) => {
    for (const selector of selectors) {
      const node = root.querySelector(selector);
      if (node) return node;
    }
    return null;
  };

  const onProductPage = () => {
    const path = window.location.pathname.replace(/\/$/, '').toLowerCase();
    if (path !== '/products/sinlipomas') return false;
    const productId = document.querySelector('input[name="product_id"]')?.value;
    return !productId || productId === PRODUCT_ID;
  };


  const ensureSubmitCopy = (root) => {
    const button = root.querySelector('button[type="submit"]._rsi-modal-submit-button');
    const total = button?.querySelector('.rsi-cod-form-submit-total-value');
    const holder = total?.parentElement;
    if (!button || !total || !holder) return;
    let prefix = [...holder.childNodes].find((node) => node.nodeType === Node.TEXT_NODE);
    if (!prefix) {
      prefix = document.createTextNode('');
      holder.prepend(prefix);
    }
    prefix.textContent = 'PEDIR MI 2x1 — PAGAR AL RECIBIR — ';
    button.dataset.slCtaCopy = 'true';
    button.setAttribute('aria-label', `Pedir mi 2x1, pagar al recibir, total ${total.textContent.trim()}`);
  };

  const ensureDeliveryCopy = (root) => {
    const customTexts = [...root.querySelectorAll('._rsi-custom-text-field')];
    const fieldsHeading = customTexts.find((node) => /Escribe tus datos de envío/i.test(node.textContent));
    if (fieldsHeading) {
      fieldsHeading.textContent = '2 - Completa tus datos de entrega';
      fieldsHeading.dataset.slDeliveryHeading = 'true';
      let note = root.querySelector('.sl-releasit-delivery-note');
      if (!note) {
        note = document.createElement('div');
        note.className = 'sl-releasit-delivery-note';
        note.textContent = 'Te contactaremos por WhatsApp para confirmar el pedido.';
      }
      fieldsHeading.after(note);
    }
    const coverage = customTexts.find((node) => /municipio NO se despliega|transportadora no tiene cobertura/i.test(node.textContent));
    if (coverage) {
      coverage.textContent = 'Selecciona tu municipio para validar cobertura. Si no aparece, contáctanos y revisaremos una alternativa.';
      coverage.dataset.slCoverageCopy = 'true';
    }
  };

  const ensureEmailRequired = (root) => {
    const email = root.querySelector('input[type="email"][name="email"]');
    const field = email?.closest('._rsi-modal-fields-item');
    const label = field?.querySelector('label');
    if (!email || !label) return;
    email.required = true;
    email.setAttribute('required', 'required');
    email.setAttribute('aria-required', 'true');
    label.textContent = 'Correo electrónico';
    const marker = document.createElement('span');
    marker.className = '_rsi-modal-required-label';
    marker.textContent = '*';
    label.append(marker);
    label.dataset.slEmailRequired = 'true';
  };

  const ensureOfferIntro = (root) => {
    const heading = findFirst(root, ['._rsi-custom-text-field', '._rsi-quantity-offers-main-title']);
    if (!heading) return;
    heading.textContent = 'OFERTA 2x1: PAGA 1 Y RECIBE 2';
    heading.dataset.slOfferHeading = 'true';

    let summary = root.querySelector('.sl-releasit-cro-summary');
    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'sl-releasit-cro-summary';
      const lead = document.createElement('strong');
      lead.textContent = `Recibe 2 sprays de 60 ml de SinLipomas por ${config.basePriceText || 'el total indicado'} en total.`;
      const cod = document.createElement('span');
      cod.textContent = 'Envío incluido y pago contraentrega. Pagas cuando recibes tu pedido.';
      const instruction = document.createElement('span');
      instruction.textContent = 'Selecciona tu oferta y completa los datos de entrega.';
      summary.append(lead, cod, instruction);
    }

    let status = root.querySelector('.sl-releasit-offer-status');
    if (!status) {
      status = document.createElement('div');
      status.className = 'sl-releasit-offer-status';
      status.textContent = '2x1 vigente — pide hoy y paga cuando recibas';
    }
    heading.after(summary, status);
    root.querySelectorAll('.sl-releasit-offer-timer,.sl-releasit-assurance,.sl-releasit-base-price,.sl-releasit-base-saving').forEach((node) => node.remove());
  };

  const offerQuantity = (offer, root) => {
    const offers = [...root.querySelectorAll('._rsi-quantity-offers-offer')];
    const position = offers.indexOf(offer);
    return OFFER_ORDER[position] || null;
  };

  const enhanceOffer = (offer, root) => {
    const quantity = offerQuantity(offer, root);
    const copy = OFFER_COPY[quantity];
    if (!copy) return;

    const title = findFirst(offer, ['._rsi-quantity-offers-title', '[class*="quantity-offers-title"]']);
    if (title) {
      title.textContent = copy.title;
      title.dataset.slOfferCopy = 'true';
    }

    const plaque = findFirst(offer, ['._rsi-quantity-offers-plaque', '[class*="quantity-offers-plaque"]']);
    if (plaque) {
      plaque.textContent = copy.plaque;
      plaque.dataset.slOfferCopy = 'true';
    }

    const info = findFirst(offer, ['._rsi-quantity-offers-info', '[class*="quantity-offers-info"]']);
    if (info) {
      let detail = info.querySelector('.sl-releasit-offer-detail');
      if (!detail) {
        detail = document.createElement('div');
        detail.className = 'sl-releasit-offer-detail';
        info.append(detail);
      }
      detail.textContent = copy.detail;
    }

    const image = findFirst(offer, ['img._rsi-modal-line-item-image', 'img[class*="modal-line-item-image"]']);
    if (image && copy.image) {
      image.src = copy.image;
      image.removeAttribute('srcset');
      image.alt = `Recibes ${quantity} SinLipomas`;
      image.loading = 'lazy';
      image.decoding = 'async';
    }
  };

  const selectedOfferIndex = (root) => {
    const offers = [...root.querySelectorAll('._rsi-quantity-offers-offer-container')];
    const index = offers.findIndex((offer) => offer.classList.contains('_rsi-quantity-offers-selected'));
    return index >= 0 ? index : 0;
  };

  const updateSummaryImage = (root) => {
    const image = [...root.querySelectorAll('img._rsi-modal-line-item-image')]
      .find((node) => !node.closest('._rsi-quantity-offers-offer-container'));
    const quantity = OFFER_ORDER[selectedOfferIndex(root)] || OFFER_ORDER[0];
    const source = OFFER_COPY[quantity]?.image;
    if (!image || !source) return;
    image.src = source;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.alt = `Recibes ${quantity} SinLipomas`;
  };

  const ensureDiscountSummary = (root) => {
    const quantity = OFFER_ORDER[selectedOfferIndex(root)] || OFFER_ORDER[0];
    const pricing = SUMMARY_PRICING[quantity];
    const subtotalLine = root.querySelector('[data-checkout-line="subtotal"]');
    const totalLine = root.querySelector('[data-checkout-line="total"]');
    const subtotalValue = subtotalLine?.querySelector('._rsi-modal-checkout-line-value');
    const totalValue = totalLine?.querySelector('._rsi-modal-checkout-line-value');
    if (!pricing || !subtotalLine || !totalLine || !subtotalValue || !totalValue) return;

    // Wait for Releasit to finish recalculating the selected offer. This layer
    // only mirrors its settled total and never changes checkout data or inputs.
    if (parseCOP(totalValue.textContent) !== pricing.total) return;

    subtotalValue.textContent = formatCOP(pricing.subtotal);
    subtotalLine.dataset.slDisplaySubtotal = String(pricing.subtotal);

    let discountLine = root.querySelector('[data-checkout-line="discount"]');
    if (!discountLine) {
      discountLine = document.createElement('div');
      discountLine.className = '_rsi-modal-checkout-line';
      discountLine.dataset.checkoutLine = 'discount';
      const title = document.createElement('span');
      title.className = '_rsi-modal-checkout-line-title';
      const value = document.createElement('span');
      value.className = '_rsi-modal-checkout-line-value';
      discountLine.append(title, value);
      totalLine.before(discountLine);
    }
    const discountTitle = discountLine.querySelector('._rsi-modal-checkout-line-title');
    const discountValue = discountLine.querySelector('._rsi-modal-checkout-line-value');
    if (!discountTitle || !discountValue) return;
    discountTitle.textContent = 'Descuentos';
    discountValue.textContent = `- ${formatCOP(pricing.discount)}`;
    discountLine.dataset.slDiscountSummary = String(pricing.discount);
  };

  let activeRoot = null;
  let hydrationObserver = null;
  let discoveryObserver = null;
  let discoveryTimeout = null;

  const stopHydrationObserver = () => {
    if (hydrationObserver) hydrationObserver.disconnect();
    hydrationObserver = null;
  };

  const stopDiscoveryObserver = () => {
    if (discoveryObserver) discoveryObserver.disconnect();
    discoveryObserver = null;
    if (discoveryTimeout) window.clearTimeout(discoveryTimeout);
    discoveryTimeout = null;
  };

  const enhance = () => {
    if (!onProductPage()) return;
    const root = document.querySelector('#_rsi-cod-form-modal');
    if (!root) return;
    const offers = root.querySelectorAll('._rsi-quantity-offers-offer');
    if (offers.length < OFFER_ORDER.length) return;
    activeRoot = root;
    root.dataset.slCroEnhanced = 'true';
    stopDiscoveryObserver();
    ensureOfferIntro(root);
    ensureDeliveryCopy(root);
    ensureEmailRequired(root);
    ensureSubmitCopy(root);
    offers.forEach((offer) => enhanceOffer(offer, root));
    updateSummaryImage(root);
    ensureDiscountSummary(root);
  };

  let queued = false;
  const queueEnhance = () => {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(() => {
      queued = false;
      enhance();
    });
  };

  const watchModalHydration = (root) => {
    if (!root) return;
    if (root !== activeRoot || !hydrationObserver) {
      stopHydrationObserver();
      activeRoot = root;
      hydrationObserver = new MutationObserver(queueEnhance);
      hydrationObserver.observe(root, { childList: true, subtree: true });
    }
    queueEnhance();
  };

  const ensureDiscoveryObserver = () => {
    if (discoveryObserver || !document.body) return;
    discoveryObserver = new MutationObserver(() => {
      const modal = document.querySelector('#_rsi-cod-form-modal');
      if (modal && modal !== activeRoot) {
        watchModalHydration(modal);
      }
    });
    discoveryObserver.observe(document.body, { childList: true, subtree: true });
    discoveryTimeout = window.setTimeout(stopDiscoveryObserver, 5000);
  };

  const discoverModal = () => {
    ensureDiscoveryObserver();
    const root = document.querySelector('#_rsi-cod-form-modal');
    if (root) {
      watchModalHydration(root);
    }
  };

  const refreshAfterOfferInteraction = (event) => {
    if (!event.target.closest('#_rsi-cod-form-modal')) return;
    queueEnhance();
    window.setTimeout(queueEnhance, 120);
    window.setTimeout(queueEnhance, 350);
    window.setTimeout(queueEnhance, 1200);
  };

  const enhancePurchaseControls = () => {
    document.querySelectorAll('._rsi-buy-now-button').forEach((button) => {
      if (!button.hasAttribute('role')) button.setAttribute('role', 'button');
      if (!button.hasAttribute('tabindex')) button.setAttribute('tabindex', '0');
      if (!button.hasAttribute('aria-label')) button.setAttribute('aria-label', 'Abrir formulario de pedido y ver ofertas');
      if (button.dataset.slKeyboardReady !== 'true') {
        button.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          button.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        });
        button.dataset.slKeyboardReady = 'true';
      }
    });
  };

  let purchaseControlObserver = null;
  let purchaseControlTimeout = null;
  const stopPurchaseControlObserver = () => {
    if (purchaseControlObserver) purchaseControlObserver.disconnect();
    purchaseControlObserver = null;
    if (purchaseControlTimeout) window.clearTimeout(purchaseControlTimeout);
    purchaseControlTimeout = null;
  };
  const discoverPurchaseControls = () => {
    enhancePurchaseControls();
    if (document.querySelector('._rsi-buy-now-button')) {
      stopPurchaseControlObserver();
      return;
    }
    if (purchaseControlObserver || !document.body) return;
    purchaseControlObserver = new MutationObserver(() => {
      enhancePurchaseControls();
      if (document.querySelector('._rsi-buy-now-button')) stopPurchaseControlObserver();
    });
    purchaseControlObserver.observe(document.body, { childList: true, subtree: true });
    purchaseControlTimeout = window.setTimeout(stopPurchaseControlObserver, 5000);
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('._rsi-buy-now-button')) discoverModal(true);
    refreshAfterOfferInteraction(event);
  }, true);
  document.addEventListener('change', refreshAfterOfferInteraction, true);
  const initialize = () => {
    discoverPurchaseControls();
    discoverModal(false);
  };
  document.addEventListener('DOMContentLoaded', initialize, { once: true });
  document.addEventListener('startasyncloading', discoverPurchaseControls, { once: true });
  window.addEventListener('load', discoverPurchaseControls, { once: true });
  if (document.readyState !== 'loading') initialize();
})();
